import { makeStyles } from "@material-ui/core";
import { DESKTOP_BREAKPOINT } from "../../consts";
import { ro } from "date-fns/locale";

export const useAboutMeStyles = makeStyles((theme) => ({
  outerWrapper: {
    position: "relative",
    overflow: "visible",
  },

  wrapper: {
    position: "relative",
    margin: "0 auto",
    padding: "96px",
    fontFamily: "'Inter', sans-serif",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      padding: "48px 20px",
    },
  },
  wrapperWithoutPadding: {
    position: "relative",
    margin: "0 auto",
    fontFamily: "'Inter', sans-serif",
  },

  handsImage: {
    position: "absolute",
    left: "-35px",
    top: "20%",
    transform: "translateY(-50%) rotate(30deg)",
    width: "128px",
    height: "auto",
    opacity: 0.9,
    zIndex: 1,
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "48px",
      left: "-14px",
      top: "10%",
    },
  },

  titleWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
  },

  hiddenInput: {
    display: "none",
  },

  title: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "42px",
    lineHeight: 1.4,
    fontWeight: 700,
    color: "#404040",
    letterSpacing: '-4%',
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "24px",
    },
  },

  titleME: {
    color: '#C79000',
    position: "relative",
  },

  highlightImg: {
    position: "absolute",
    bottom: "-10px",
    left: 7,
    width: "65px",
    height: "auto",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "32px",
      left: 3,
    },
  },

  videosHighlightImg: {
    position: "absolute",
    bottom: "-10px",
    left: 45,
    width: "65px",
    height: "auto",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "32px",
      left: 20,
    },
  },

  description: {
    fontSize: "16px",
    color: "#404040",
    marginBottom: "24px",
    letterSpacing: '-4%',
    fontWeight: '600',
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "14px",
    },
  },

  expertiseSection: {
    marginBottom: "24px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      marginBottom: "24px",
      flexDirection: "column",
      alignItems: 'flex-start'
    },
  },

  sectionLabel: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#404040",
    letterSpacing: '-4%',

    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "14px",
    },
  },

  expertiseChips: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      gap: "8px",
    },
  },

  expertiseChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "8px 16px",
    borderRadius: "32px",
    border: "3px solid #DBDBFF",
    backgroundColor: "#fff",
    fontSize: "16px",
    fontWeight: 700,
    color: "#404040",
    "& img": {
      width: "20px",
      height: "20px",
    },
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      border: "2px solid #DBDBFF",
      fontSize: "14px",
    },
  },

  academicSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flexDirection: "column",
      alignItems: 'flex-start',
    },
  },

  academicSectionLabel: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#404040",
    letterSpacing: '-4%',
    minWidth: "200px",
    flexShrink: 0,
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "16px",
      minWidth: "unset",
    },
  },
  academicSectionLabelContact: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#404040",
    letterSpacing: '-4%',
    minWidth: "200px",
    flexShrink: 0,
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "16px",
      minWidth: "unset",
    },
  },

  academicGrid: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flexDirection: "column",
      width: "100%",
      gap: "8px",
    },
  },

  academicItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: "250px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "100%",
    },
  },

  academicIcon: {
    width: "24px",
    height: "24px",
    flexShrink: 0,
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "20px",
      height: "20px",
    },
  },

  academicText: {
    fontSize: "16px",
    color: "#404040",
    fontWeight: 600,
    letterSpacing: '-4%',
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "14px",
    },
  },

  verticalDivider: {
    width: "2px",
    height: "32px",
    backgroundColor: "#E6E6E6",
    flexShrink: 0,
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "none",
    },
  },

  contactSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
    marginTop: "24px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  videosSection: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "64px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      marginTop: "48px",
      gap:"8px"
    },
  },

  videosSectionTitle: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "42px",
    lineHeight: 1.4,
    fontWeight: 700,
    color: "#404040",
    letterSpacing: '-4%',
    marginBottom: "16px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "24px",
    },
  },

  videosRow: {
    display: "flex",
    flexDirection: "row",
    gap: "24px",
    flexWrap: "wrap",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flexDirection: "column",
    },
  },

  videoCard: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    border: " 2px solid #E6E6E6",
    borderRadius: "12px",
    padding: "8px",
  },

  videoThumbnail: {
    width: "390px",
    height: "254px",
    borderRadius: "12px",
    objectFit: "cover",
    backgroundColor: "#1a1a1a",
    display: "block",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "100%",
    },
  },

  videoLabelRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "390px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "100%",
      maxWidth: "280px",
    },
  },

  videoLabel: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#404040",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "14px",
    },
  },

  replaceBtn: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#3377FF",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    "&:hover": {
      textDecoration: "underline",
    },
    "& svg": {
      width: "14px",
      height: "14px",
      transform: "rotate(80deg) scaleX(-1)",
    },
  },
}));
